module.exports = __webpack_public_path__ + "227f6d0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/icons/home-001.jpg
// module id = 1307
// module chunks = 8